export default __webpack_public_path__ + "static/media/ky.5d31f19a.svg";